import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

interface Props {
  amount?: number
  onConfirm: () => void | Promise<void>
}

export const ResubscribeModal: BaseModalType<Props> = (props) => {
  const { amount, onConfirm, close } = props
  const { t } = useTranslation()

  return (
    <Modal>
      <Modal.Header>{t('Subscriptions.Resubscribe')}?</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>
          <p className='text'>
            {t('Market Data.You subscription will be Active again', {
              amount,
            })}
          </p>
        </Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Cancel')}</Modal.Footer.Secondary>
        <Modal.Footer.Primary
          onClick={() => {
            void onConfirm()
            close()
          }}
        >
          {t('Subscriptions.Resubscribe')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
